module.exports = __webpack_public_path__ + "img/teacher1.02851a08.webp";